import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

import hello from "../images/hello.svg"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div className="px-2 py-6">
      <h1 className="">Hi</h1>
      <img
        src={hello}
        alt=""
        className="w-1/4 rounded-full border-8 border-gray-500 bg-gray-700"
      />
    </div>
  </Layout>
)

export default IndexPage
